import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./product-preview-button.css";

interface ProductPreviewButtonProps {
    onClick: () => void;
}

export default function ProductPreviewButton({ onClick }: ProductPreviewButtonProps): JSX.Element {
    function handleClick(): void {
        analytics.event("feeds", "click_product_preview_button", "click");
        onClick();
    }

    return (
        <button
            aria-label={gettext("product.buy_area.preview")}
            className={styles.button}
            onClick={handleClick}
        >
            <SVGIcon className={styles.svg} name={"preview-icon"} />
        </button>
    );
}
